module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTAwIiBoZWlnaHQ9IjI1MDAiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjMDA4NGZmIiBkPSJNNTEyIDBIMHY1MTJoNTEyeiIvPjxwYXRoIGQ9Ik0yNTcgOTNjLTg4LjkxOCAwLTE2MSA2Ny4xNTctMTYxIDE1MCAwIDQ3LjIwNSAyMy40MTIgODkuMzExIDYwIDExNi44MDdWNDE3bDU0LjgxOS0zMC4yNzNDMjI1LjQ0OSAzOTAuODAxIDI0MC45NDggMzkzIDI1NyAzOTNjODguOTE4IDAgMTYxLTY3LjE1NyAxNjEtMTUwUzM0NS45MTggOTMgMjU3IDkzem0xNiAyMDJsLTQxLTQ0LTgwIDQ0IDg4LTk0IDQyIDQ0IDc5LTQ0LTg4IDk0eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook-messenger-white.svg
// module id = 2527
// module chunks = 2